import React from 'react';
import Icon from '../../../components/AppIcon';

const NotificationPanel = ({ notifications }) => {
  const getNotificationIcon = (type) => {
    switch (type) {
      case 'reminder':
        return 'Bell';
      case 'update':
        return 'Info';
      case 'warning':
        return 'AlertTriangle';
      case 'success':
        return 'CheckCircle';
      case 'proximity_alert':
        return 'MapPin';
      default:
        return 'Bell';
    }
  };

  const getNotificationStyle = (type) => {
    switch (type) {
      case 'reminder':
        return 'bg-primary/10 text-primary border-primary/20';
      case 'update':
        return 'bg-secondary/10 text-secondary border-secondary/20';
      case 'warning':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'success':
        return 'bg-success/10 text-success border-success/20';
      case 'proximity_alert':
        return 'bg-orange-500/10 text-orange-600 border-orange-500/20 animate-pulse';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const formatNotificationTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    
    if (diffMins < 1) return 'À l\'instant';
    if (diffMins < 60) return `Il y a ${diffMins} min`;
    
    const diffHours = Math.floor(diffMins / 60);
    if (diffHours < 24) return `Il y a ${diffHours}h`;
    
    return date?.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' });
  };

  if (!notifications || notifications?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card rounded-lg p-6 shadow-sm border border-border">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Notifications</h3>
        <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
          {notifications?.length}
        </span>
      </div>
      <div className="space-y-3">
        {notifications?.map((notification) => (
          <div
            key={notification?.id}
            className={`p-4 rounded-lg border ${getNotificationStyle(notification?.type)}`}
          >
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 mt-0.5">
                <Icon 
                  name={getNotificationIcon(notification?.type)} 
                  size={18} 
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground mb-1">
                  {notification?.title}
                </p>
                <p className="text-xs text-muted-foreground mb-2">
                  {notification?.message}
                </p>
                <span className="text-xs text-muted-foreground">
                  {formatNotificationTime(notification?.timestamp)}
                </span>
              </div>
              {notification?.actionable && (
                <button className="flex-shrink-0 text-xs font-medium hover:underline">
                  Voir
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationPanel;